export const BERLIN_LOGO_URL = `${process.env.PUBLIC_URL || ""}/berlin-logo.png`;

export const BERLIN_LOGO_SHAREPOINT_VIEWER =
  "https://elementinformaticsindia-my.sharepoint.com/personal/aman_elementtechnologies_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Faman_elementtechnologies_com%2FDocuments%2FMicrosoft%20Teams%20Chat%20Files%2Fberlin-logo.png&parent=%2Fpersonal%2Faman_elementtechnologies_com%2FDocuments%2FMicrosoft%20Teams%20Chat%20Files&ga=1";

export const BERLIN_LOGO_LOCAL = `${process.env.PUBLIC_URL || ""}/berlin-logo.png`;
